// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e7f70d6b","644":"6562573e"}[chunkId] + ".chunk.js";
};